import { Component, computed, inject, OnInit } from '@angular/core';
import { DisplayComponent } from '@app/shared/components/display/display.component';
import { Display, FontSizeRescalerService } from '@app/shared/services/font-rescaler.service';
import { SharedModule } from '@app/shared/shared.module';
import { AnimatedTimerComponent } from '@app/shared/components/animated-timer/animated-timer.component';
import { RecurringFacade } from './recurring.facade';
import { AvoidMulticlickDirective } from '@app/shared/directives/avoid-multiclick.directive';
import { LoggerService } from '@app/shared/services/logger.service';
import { UserRepository } from '@app/shared/state/user/user.repository';

@Component({
  selector: 'slotcom-recurring',
  templateUrl: './recurring.component.html',
  styleUrls: ['./recurring.component.scss'],
  standalone: true,
  imports: [DisplayComponent, AnimatedTimerComponent, SharedModule, AvoidMulticlickDirective],
})
export class RecurringComponent implements OnInit {
  private readonly fontSizeRescaler = inject(FontSizeRescalerService);
  private readonly recurringFacade = inject(RecurringFacade);
  private readonly logger = inject(LoggerService);
  private readonly userRepo = inject(UserRepository);

  readonly isRecurringLocked = this.userRepo.recurringLocked;

  recurring = this.recurringFacade.recurring;
  isReadyToCollect = this.recurringFacade.isReadyToCollect;

  fontSize = computed(() => {
    const bonus = this.recurring()?.nextBonus ?? 0;
    return this.fontSizeRescaler.setFontSize(Display.LTEDisplay, bonus);
  });

  ngOnInit(): void {
    this.recurringFacade.load();
  }

  redeemRecurring = async (): Promise<void> => {
    if (!this.isReadyToCollect()) return;

    await this.recurringFacade.redeem().catch((err) => this.logger.error(err));
  };

  onExpiredRecurring(): void {
    this.recurringFacade.markExpired();
  }
}
